"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdjustmentFileValidator = void 0;
var _decimal = _interopRequireDefault(require("decimal.js"));
var _excel = require("@/utils/excel");
var _config = require("@/config");
var _transforms = require("@/utils/transforms");
var _utils = require("@/utils/utils");
var _rawAdjustmentChunkProcessor = require("../chunk/rawAdjustmentChunkProcessor");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class AdjustmentFileValidator {
  constructor({
    cache,
    excelClient,
    fileId,
    fileName,
    filePath,
    logger,
    s3Client,
    snowflakeClient
  }) {
    this.cache = cache;
    this.excelClient = excelClient;
    this.fileId = fileId;
    this.fileName = fileName;
    this.filePath = filePath;
    this.logger = logger;
    this.s3Client = s3Client;
    this.snowflakeClient = snowflakeClient;
    this.isFileValid = true;
  }

  /**
   * Read and validates adjustment file content.
   *  - The function reads the file data in batches and validates it.
   *  - It will add the "Error" column to existing excel sheet
   *    in case if there are any validation errors and
   *    uploads excel sheet to s3 bucket.
   *  - Also, calculates the total number of valid/invalid adjustment rows,
   *    valid/invalid adjustment amount
   *
   * @returns A tuple of valid/invalid adjustment rows count,
   *    total adjustment amount and error message
   */
  async validate() {
    this.logger?.info("Reading excel sheet");
    let totalInvalidRows = 0;
    let totalRows = 0;
    let totalFileAmount = new _decimal.default(0);
    let error = undefined;
    let errorType = undefined;
    let hasRows = false;
    let hasHeaders = false;
    let headers = [];
    const rowStream = this.excelClient.streamRows(this.filePath, 0).filter(row => {
      // Remove empty rows
      if (row.isEmpty) {
        return false;
      }

      // Remove leading spaces, trailing spaces, and special characters
      row.cells.forEach(cell => {
        cell.raw = (0, _utils.stripSpecialCharactersAndSpaces)(cell.raw);
        if (cell.type == _excel.CellType.String) {
          cell.value = (0, _utils.stripSpecialCharactersAndSpaces)(cell.value);
        }
      });

      // Get headers
      if (hasHeaders) {
        hasRows = true;
      } else {
        hasHeaders = true;
        headers = (0, _utils.parseHeaders)(row);
      }
      return hasRows;
    });
    const chunkStream = rowStream.pipe((0, _transforms.chunk)(_config.config.chunkSize));
    const processor = new _rawAdjustmentChunkProcessor.RawAdjustmentChunkProcessor({
      cache: this.cache,
      snowflakeClient: this.snowflakeClient
    });
    await chunkStream.forEach(async chunk => {
      this.logger?.info(`Validating adjustments rows from ${chunk[0].index} to ${chunk.at(-1).index}`);
      totalRows += chunk.length;
      const rawChunk = chunk.map(row => (0, _utils.toRawAdjustment)(headers, row.cells));
      const {
        data,
        errors
      } = await processor.process(rawChunk);
      for (const {
        value
      } of data) {
        totalFileAmount = totalFileAmount.plus(value.amount);
      }
      if (errors.length > 0) {
        this.isFileValid = false;
        this.logger?.error(JSON.stringify(errors));
        totalInvalidRows += errors.length;
        errorType = "Validation Error";
        this.logger?.info("Writing validation errors to excel sheet");
        // this.writeErrorColumn(sheet, new_column_num, validation_errors)
      }
    });
    if (!hasRows) {
      errorType = "Empty File";
      error = "No adjustments records found in excel sheet";
      return {
        error,
        errorType
      };
    }

    // If there are validation errors, upload an error report to the S3 bucket.
    if (!this.isFileValid) {
      /*
      const errorFilePath = `${this.fileId}/${this.fileId}-error.xlsx`;
      this.s3Client.writeFile(errorFilePath, createReadStream("TODO"), {
          bucket: config.s3.bucketName
      });
      */
      error = "Validation errors has been added to the file.";
    }
    const totalValidRows = totalRows - totalInvalidRows;
    this.logger?.info("File validated successfully.");
    return {
      totalValidRows,
      totalInvalidRows,
      totalFileAmount: totalFileAmount.toString(),
      roundedAmount: totalFileAmount.toDecimalPlaces(2, _decimal.default.ROUND_UP).toString(),
      error,
      errorType
    };
  }
}
exports.AdjustmentFileValidator = AdjustmentFileValidator;